import { useEffect } from 'react';

import { useOnceReveal } from '@common/hooks';

import { Benefit, getBenefitType } from './getBenefitType';
import { useMaximumBenefitLog } from './useMaximumBenefitLog';

interface Props {
  product_id: string;
  maximumBenefitPrice: number;
  benefitType: Benefit;
  has_data: boolean;
}

export const useSendPageviewMaximumBenefit = ({ product_id, maximumBenefitPrice, benefitType, has_data }: Props) => {
  const { targetRef, isRevealed } = useOnceReveal();
  const { pageviewMaximumBenefitUBL } = useMaximumBenefitLog();

  useEffect(() => {
    if (isRevealed && has_data) {
      const parse_benefit_type = getBenefitType(benefitType);
      pageviewMaximumBenefitUBL(product_id, maximumBenefitPrice, parse_benefit_type);
    }
  }, [isRevealed, has_data]);

  return {
    targetRef,
  };
};
